import { useContext, useCallback } from 'react';
import { AccessDataContext } from '../contextProviders/AccessDataContext';

export const useApiCalls = () => {
  const { logoutUser } = useContext(AccessDataContext);

  const requestOptions = useCallback(
    (method: string, body?: any): globalThis.RequestInit => ({
      method,
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
      },
      credentials: "include",
      ...(body && { body: JSON.stringify(body) }),
    }),
    []
  );

  const handleResponse = useCallback(
    (response: Response) => {
      return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
          if ([401, 403].includes(response.status)) {
            logoutUser();
            window.location.reload();
          }
        }
        return data;
      });
    },
    [logoutUser]
  );

  const getQuery = useCallback(
    (url: string) => {
      return fetch(url, requestOptions("GET")).then(handleResponse);
    },
    [requestOptions, handleResponse]
  );

  const postQuery = useCallback(
    (url: string, postData?: any) => {
      return fetch(url, requestOptions("POST", postData)).then(handleResponse);
    },
    [requestOptions, handleResponse]
  );

  const postQueryFileDownload = useCallback(
    (url: string, postData?: any) => {
      return fetch(url, {
        ...requestOptions("POST", postData),
      }).then((response) => response.blob());
    },
    [requestOptions]
  );

  const getQueryFileDownload = useCallback(
    (url: string) => {
      return fetch(url, {
        ...requestOptions("GET"),
      }).then((response) => response.blob());
    },
    [requestOptions]
  );

  return { getQuery, postQuery, postQueryFileDownload, getQueryFileDownload };
};
